import isNotEmpty from "./empty-field";
import isCaptchaValid from "./is-captcha-valid-aggregator";

export default function isLoginFieldsValid(data) {
  return isNotEmpty(data.username) &&
    isNotEmpty(data.password) &&
    isCaptchaValid(data.recaptcha);
}
